<div class="chart-config-wrapper">
  <form
    *ngIf="chartConfigForm && activeChart"
    nz-form
    [nzLayout]="'vertical'"
    [formGroup]="chartConfigForm"
    class="form-grid"
  >
    <h5 nz-typography class="nfl-form-label">Chart Configuration</h5>
    <div nz-row [nzGutter]="[16, 24]">
      <div nz-col class="gutter-row" [nzSpan]="24" *ngIf="activeChart?.displayConfig?.chartTitle">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true">Chart Title </nz-form-label>
          <nz-form-control [nzErrorTip]="chartTitleErrorTemplate">
            <input
              nz-input
              formControlName="chartTitle"
              id="chartTitle"
              appTrimFormInput
              placeholder="Chart Title"
              [readonly]="isEditMode"
              [ngClass]="{ 'readonly-input': isEditMode }"
            />
          </nz-form-control>
        </nz-form-item>
        <ng-template #chartTitleErrorTemplate let-control>
          <div *ngIf="control?.errors?.['maxlength']">
            Chart title cannot exceed
            {{ control?.errors?.['maxlength'].requiredLength }} characters.
          </div>
        </ng-template>
      </div>
    </div>
    <div nz-row [nzGutter]="[16, 24]">
      <div nz-col class="gutter-row" [nzSpan]="12" *ngIf="activeChart?.displayConfig?.xAxisLabel">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true">X-Axis Label </nz-form-label>
          <nz-form-control [nzErrorTip]="xAxisLabelErrorTemplate">
            <input
              nz-input
              formControlName="xAxisLabel"
              id="xAxisLabel"
              appTrimFormInput
              placeholder="X-Axis Label"
              [readonly]="isEditMode"
              [ngClass]="{ 'readonly-input': isEditMode }"
            />
          </nz-form-control>
        </nz-form-item>
        <ng-template #xAxisLabelErrorTemplate let-control>
          <div *ngIf="control?.errors?.['maxlength']">
            X-Axis label cannot exceed
            {{ control?.errors?.['maxlength'].requiredLength }} characters.
          </div>
        </ng-template>
      </div>
      <div nz-col class="gutter-row" [nzSpan]="12" *ngIf="activeChart?.displayConfig?.yAxisLabel">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true">Y-Axis Label </nz-form-label>
          <nz-form-control [nzErrorTip]="yAxisLabelErrorTemplate">
            <input
              nz-input
              formControlName="yAxisLabel"
              id="yAxisLabel"
              appTrimFormInput
              placeholder="Y-Axis Label"
              [readonly]="isEditMode"
              [ngClass]="{ 'readonly-input': isEditMode }"
            />
          </nz-form-control>
        </nz-form-item>
        <ng-template #yAxisLabelErrorTemplate let-control>
          <div *ngIf="control?.errors?.['maxlength']">
            Y-Axis label cannot exceed
            {{ control?.errors?.['maxlength'].requiredLength }} characters.
          </div>
        </ng-template>
      </div>
    </div>

    <div
      nz-row
      [nzGutter]="[16, 24]"
      *ngIf="activeChart?.displayConfig?.xAxisValue || activeChart?.displayConfig?.yAxisValue"
    >
      <div nz-col class="gutter-row" [nzSpan]="12">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true"> X-Axis</nz-form-label>
          <nz-form-control nzErrorTip="X-Axis Value is required">
            <nz-select
              formControlName="xAxisValue"
              nzAllowClear
              nzPlaceHolder="Choose Value"
              nzLoading="false"
              [nzDisabled]="isEditMode"
            >
              <nz-option
                *ngFor="let value of categoricalCols; index as i"
                [nzValue]="value"
                [nzLabel]="value"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col class="gutter-row" [nzSpan]="12">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true"> Y-Axis</nz-form-label>
          <nz-form-control nzErrorTip=" Y-Axis Value is required">
            <nz-select
              formControlName="yAxisValue"
              nzAllowClear
              nzPlaceHolder="Choose Value"
              nzLoading="false"
              [nzDisabled]="isEditMode"
            >
              <nz-option *ngFor="let value of numericCols; index as i" [nzValue]="value" [nzLabel]="value"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div
      nz-row
      [nzGutter]="[16, 24]"
      *ngIf="activeChart?.displayConfig?.category || activeChart?.displayConfig?.categoryValue"
    >
      <div nz-col class="gutter-row" [nzSpan]="12">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true">Category</nz-form-label>
          <nz-form-control nzErrorTip="Category is required">
            <nz-select
              formControlName="category"
              nzAllowClear
              nzPlaceHolder="Choose Value"
              nzLoading="false"
              [nzDisabled]="isEditMode"
            >
              <nz-option
                *ngFor="let value of categoricalCols; index as i"
                [nzValue]="value"
                [nzLabel]="value"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col class="gutter-row" [nzSpan]="12">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true"> Value</nz-form-label>
          <nz-form-control nzErrorTip="Value is required">
            <nz-select
              formControlName="categoryValue"
              nzAllowClear
              nzPlaceHolder="Choose Value"
              nzLoading="false"
              [nzDisabled]="isEditMode"
            >
              <nz-option *ngFor="let value of numericCols; index as i" [nzValue]="value" [nzLabel]="value"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row [nzGutter]="[16, 24]" *ngIf="activeChart?.displayConfig?.mapType">
      <div nz-col class="gutter-row" [nzSpan]="12">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true">Map Type</nz-form-label>
          <nz-form-control>
            <nz-select
              formControlName="mapType"
              nzAllowClear
              nzPlaceHolder="Select Map Type"
              nzLoading="false"
              [nzDisabled]="isEditMode"
            >
              <nz-option nzValue="USA States" nzLabel="USA States"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div
      nz-row
      [nzGutter]="[16, 24]"
      *ngIf="activeChart?.displayConfig?.location || activeChart?.displayConfig?.locationValue"
    >
      <div nz-col class="gutter-row" [nzSpan]="12">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true">Location/Region</nz-form-label>
          <nz-form-control nzErrorTip="Location is required">
            <nz-select
              formControlName="location"
              nzAllowClear
              nzPlaceHolder="Choose Value"
              nzLoading="false"
              [nzDisabled]="isEditMode"
            >
              <nz-option
                *ngFor="let value of categoricalCols; index as i"
                [nzValue]="value"
                [nzLabel]="value"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col class="gutter-row" [nzSpan]="12">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true"> Value</nz-form-label>
          <nz-form-control nzErrorTip="Value is required">
            <nz-select
              formControlName="locationValue"
              nzAllowClear
              nzPlaceHolder="Choose Value"
              nzLoading="false"
              [nzDisabled]="isEditMode"
            >
              <nz-option *ngFor="let value of numericCols; index as i" [nzValue]="value" [nzLabel]="value"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="[16, 24]">
      <div nz-col class="gutter-row" [nzSpan]="3" *ngIf="activeChart?.displayConfig?.chartColor">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true"> Color</nz-form-label>
          <nz-form-control>
            <nz-color-picker nzShowText formControlName="chartColor" [nzDisabled]="isEditMode"></nz-color-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col class="gutter-row" [nzSpan]="6" *ngIf="activeChart?.displayConfig?.barWidth">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true"> Bar Width</nz-form-label>
          <nz-form-control>
            <nz-slider formControlName="barWidth" [nzDisabled]="isEditMode" [nzMin]="1"></nz-slider>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col class="gutter-row" [nzSpan]="6" *ngIf="activeChart?.displayConfig?.pointSize">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true"> Point Size</nz-form-label>
          <nz-form-control>
            <nz-slider formControlName="pointSize" [nzDisabled]="isEditMode" [nzMin]="1" [nzMax]="20"></nz-slider>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div
        nz-col
        class="gutter-row"
        [nzSpan]="4"
        *ngIf="activeChart?.displayConfig?.xAxisGridLines || activeChart?.displayConfig?.xAxisGridLines"
      >
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true"> Grid Lines</nz-form-label>
          <nz-form-control>
            <label nz-checkbox formControlName="yAxisGridlines" [nzDisabled]="isEditMode">X Axis </label>
            <label nz-checkbox formControlName="xAxisGridlines" [nzDisabled]="isEditMode">Y Axis </label>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col class="gutter-row" [nzSpan]="6" *ngIf="activeChart?.displayConfig?.colorPalette">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true"> Color Pallette</nz-form-label>
          <nz-form-control>
            <nz-select formControlName="colorPalette" nzPlaceHolder="Select a palette" [nzDisabled]="isEditMode">
              <nz-option
                *ngFor="let palette of palettes"
                [nzValue]="palette.id"
                [nzLabel]="palette.label"
                nzCustomContent
              >
                <div class="palette-option">
                  <span
                    *ngFor="let color of palette.colors"
                    class="color-box"
                    [ngStyle]="{ 'background-color': color }"
                  ></span>
                </div>
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-divider *ngIf="chartConfigForm.valid"></nz-divider>

    <app-chart-preview
      *ngIf="chartConfigForm.valid && isChartPreviewAvailable"
      [type]="activeChart.type"
      [chartPreviewData]="chartPreviewData"
      [configForm]="chartConfigForm"
      (chartSaved)="uploadAndSaveChart($event)"
    ></app-chart-preview>
  </form>

  <div class="footer-btn">
    <button nz-button nzType="default" nzSize="large" (click)="back()">
      <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
      <span>Back</span>
    </button>
    <button
      *ngIf="!isViewMode"
      nz-button
      nzType="primary"
      nzSize="large"
      [disabled]="chartConfigForm?.invalid || chartDetailsForm?.invalid || chartDataService.isSaveChartLoading"
      [nzLoading]="chartDataService.isSaveChartLoading"
    >
      <span (click)="saveChart()">{{ saveButtonText }}</span>
    </button>
  </div>
</div>
